import theme from './theme.grey';
export default {
  "uniqueId": "issue01",
  "appName": "support",
  "inboxType": "issue",
  "label": "Support",
  "labelColor": theme.primaryColor,
  "createdAt": "2019-06-02T06:48:00",
  "updatedAt": "2019-06-11T06:48:00",
  "messages": [{
    "uniqueId": 1,
    "status": "publish",
    "date": "2018-10-03T06:48:00",
    "author": {
      "name": "Arne Andersen",
      "email": "ivar.es@online.no"
    },
    "subject": "[#33342] Lorem ipsum dolor sit amet",
    "message": "Her er det en underlig prioritering av innholdet i bildet. Fatet er knapt synlig der det står på en hylle. Hovedmotivet er en sponhøvel, sponokse. En slik ble brukt til å høvle takspon, og ble kjørt over en stokk omtrent som en plog."
  }]
};